import { types, Instance } from 'mobx-state-tree';
import { set } from 'mobx';
import { PayPalAcp3dsContingency } from '../../../../services/PayPal3ds';

export const PayPalExpress = types
  .model({
    isDefaultPayment: types.maybeNull(types.boolean),
    publicMerchantId: types.maybeNull(types.string),
    isDelayedCapture: types.maybeNull(types.boolean),
    publicPartnerId: types.maybeNull(types.string),
    defaultCurrency: types.maybeNull(types.string),
    showCreditDebitCardLogos: types.maybeNull(types.boolean),
    showCreditButtons: types.maybeNull(types.boolean),
    showVenmoButton: types.optional(types.boolean, true),
    showMessaging: types.optional(types.boolean, false),
    config3dSecure: types.optional(types.string, 'disabled'),
  })
  .volatile(() => ({
    acpClientToken: null as string | null,
  }))
  .views(self => ({
    get fundingToDisable(): string {
      const disabledFunding: string[] = [];
      if (!self.showCreditButtons) disabledFunding.push('credit');
      if (!self.showCreditDebitCardLogos) disabledFunding.push('card');
      return disabledFunding.join(',');
    },
    get fundingToEnable(): string {
      const enabledFunding: string[] = [];
      if (self.showCreditButtons) enabledFunding.push('paylater');
      if (self.showVenmoButton) enabledFunding.push('venmo');
      return enabledFunding.join(',');
    },
    get contingencies(): string | undefined {
      switch (self.config3dSecure) {
        case 'enabled_when_required':
          return PayPalAcp3dsContingency.WhenRequired;
        case 'always_enabled':
          return PayPalAcp3dsContingency.Always;
        default:
          return undefined;
      }
    },
  }))
  .actions(self => {
    const setAcpClientToken = (clientToken: string | null): void => {
      set(self, { acpClientToken: clientToken });
    };
    const disableCreditDebitCardLogos = (): void => {
      set(self, { showCreditDebitCardLogos: false });
    };

    return {
      setAcpClientToken,
      disableCreditDebitCardLogos,
    };
  });
export interface IPayPalExpress extends Instance<typeof PayPalExpress> {}
